import React from 'react';
import { studentLearning } from '../../assets/images';

const CallToActionSection = ({ openContactModal }) => {
  return (
    <section className="cta-section" id="contact">
      <div className="cta-content">
        <div className="cta-image-container" style={{ position: 'relative' }}>
          {/* Red circle */}
          <div style={{ 
            position: 'absolute', 
            width: '15px', 
            height: '15px', 
            borderRadius: '50%', 
            backgroundColor: '#ff5c5c', 
            top: '-45px', 
            left: '30%' 
          }}></div>
          
          {/* Green circle */}
          <div style={{ 
            position: 'absolute', 
            width: '18px', 
            height: '18px', 
            borderRadius: '50%', 
            backgroundColor: '#4CAF50', 
            bottom: '-20px', 
            left: '-25px' 
          }}></div>
          
          {/* Purple circle */}
          <div style={{ 
            position: 'absolute', 
            width: '20px', 
            height: '20px', 
            borderRadius: '50%', 
            backgroundColor: '#8A2BE2', 
            right: '-55px', 
            top: '50%' 
          }}></div>
          
          {/* Blue rectangle outline */}
          <div style={{
            position: 'absolute',
            top: '-16px',
            left: '20px',
            right: '-16px',
            bottom: '20px',
            border: '3px solid #2b6cb0',
            borderRadius: '28px',
            zIndex: '0'
          }}></div>
          
          {/* Squiggly line */}
          <div style={{
            position: 'absolute',
            left: '-50px',
            top: '-25px',
            color: '#FFD700',
            fontSize: '40px',
            transform: 'rotate(90deg)'
          }}>✧</div>
          
          <img src={studentLearning} alt="Student learning AWS" className="cta-image" style={{ position: 'relative', zIndex: '1' }} />
        </div>
        <div className="cta-text">
          <h2 className="cta-heading">Your Cloud Journey Starts Here!</h2>
          <p className="cta-description">
            Get expert guidance, hands-on projects, and an awesome learning experience. Contact us to kickstart your AWS career!
          </p>
          <button className="contact-button" onClick={openContactModal}>Contact Us</button>
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection; 